var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class NGStorage {
    init(cid, aid, storage) {
        this._cid = cid;
        this._aid = aid;
        this._storage = storage;
    }
    put(ref, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const fileRef = this._storage.ref(this.getRef(ref));
            yield fileRef.put(file);
            const url = yield fileRef.getDownloadURL();
            return {
                ref,
                url,
            };
        });
    }
    delete(ref) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._storage.ref(this.getRef(ref)).delete();
        });
    }
    getRef(value) {
        return (`${this._cid}/${this._aid}/${value}`).split('//').join('/');
    }
}
//# sourceMappingURL=NGStorage.js.map